import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "../services/authentication.service";
import { Router } from "@angular/router";
@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.css']
})
export class PaymentSuccessComponent implements OnInit {
  public plan: any;
  public user: any;
  bannerPlan: any;
  bannerSizePlan: any;
  total = 0;
  constructor(public router: Router, public authenticationService: AuthenticationService) { }
  ngOnInit(): void {
    this.plan = JSON.parse(localStorage.getItem('criteria'));
    let bannerPlanDetail = JSON.parse(localStorage.getItem('bannerPlanData') || 'null');

    if (bannerPlanDetail) {
      this.bannerPlan = bannerPlanDetail.bannerPlanData;
      this.bannerSizePlan = bannerPlanDetail.bannerSizeData;
    } else {
      this.bannerPlan = null;
      this.bannerSizePlan = null;
    }

    this.user = this.authenticationService.currentUserValue;
    this.total = (this.bannerPlan && this.bannerPlan.price ? this.bannerPlan.price : 0) + (this.bannerSizePlan && this.bannerSizePlan.price ? this.bannerSizePlan.price : 0);
  }
  redirectTo() {
    if (!this.bannerPlan && !this.bannerSizePlan) {
      localStorage.removeItem('plan');
      this.router.navigate(['/dashboard']);
    }
    else {
      this.router.navigate(['/banner-ads']);
      localStorage.removeItem('bannerPlanData');
    }
  }

}
